const _ = require("lodash");
const clustering = require("density-clustering");
import { Geolocation } from "./ShoppingList";
import { ShoppingListEntry } from "./ShoppingListEntry";
import { Cluster } from "./Cluster";

// https://www.npmjs.com/package/haversine-distance
var atan2 = Math.atan2;
var cos = Math.cos;
var sin = Math.sin;
var sqrt = Math.sqrt;
var PI = Math.PI;

// (mean) radius of Earth (meters)
var R = 6378137;

function squared(x: number): number {
  return x * x;
}
function toRad(x: number): number {
  return (x * PI) / 180.0;
}

function haversineDistance(a: Geolocation, b: Geolocation): number {
  var aLat = a.latitude;
  var bLat = b.latitude;
  var aLng = a.longitude;
  var bLng = b.longitude;

  var dLat = toRad(bLat - aLat);
  var dLon = toRad(bLng - aLng);

  var f =
    squared(sin(dLat / 2.0)) +
    cos(toRad(aLat)) * cos(toRad(bLat)) * squared(sin(dLon / 2.0));
  var c = 2 * atan2(sqrt(f), sqrt(1 - f));

  return R * c;
}

class SmartOrderShoppingList {
  entries: Array<ShoppingListEntry>;

  constructor(entries: Array<ShoppingListEntry>) {
    this.entries = entries;
  }

  clustered(): Array<Cluster> {
    if (this.entries.length === 0) {
      return [];
    }

    let enhancedEntries = _.cloneDeep(this.entries);

    const entriesWithoutPosition = enhancedEntries.filter(
      (x: ShoppingListEntry) => !x.commonShoppingPosition
    );
    const entriesWithPosition = enhancedEntries.filter(
      (x: ShoppingListEntry) => x.commonShoppingPosition
    );

    let dbscan = new clustering.DBSCAN();
    // parameters: 5 - neighborhood radius, 2 - number of points in neighborhood to form a cluster
    // neighborhood distance is in meters, as returned from distance function
    let clusteredIndexes = dbscan.run(
      entriesWithPosition,
      50,
      1,
      this.distance
    );
    // Treat any unclustered items as one last cluster
    if (dbscan.noise.length > 0) {
      clusteredIndexes.push(dbscan.noise);
    }

    const clusters = clusteredIndexes.map(
      (cluster: any, clusterIndex: number) => {
        const entries = cluster.map((index: number) => {
          let entry = entriesWithPosition[index];
          entry.cluster = clusterIndex;
          return entry;
        });
        return new Cluster(entries);
      }
    );

    if (entriesWithoutPosition.length > 0) {
      clusters.push(new Cluster(entriesWithoutPosition));
    }

    return clusters;
  }

  ordered(): Array<ShoppingListEntry> {
    const clusterList = this.clustered().map((cluster) => cluster.entries);
    return _.flatten(clusterList).map((x: ShoppingListEntry) => {
      return x;
    });
  }

  distance(a: ShoppingListEntry, b: ShoppingListEntry): number {
    return haversineDistance(
      {
        latitude: a.commonShoppingPosition.latitude,
        longitude: a.commonShoppingPosition.longitude,
      },
      {
        latitude: b.commonShoppingPosition.latitude,
        longitude: b.commonShoppingPosition.longitude,
      }
    );
  }
}

export default SmartOrderShoppingList;
